// ============================================
// COMPONENT - Switch on/off para configuración de caja
// ============================================

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  descripcion: string;
  disabled?: boolean;
}

export const ToggleSwitch = ({ checked, onChange, label, descripcion, disabled }: ToggleSwitchProps) => {
  return (
    <label className={`flex items-start justify-between gap-4 py-4 ${disabled ? 'opacity-60' : 'cursor-pointer'}`}>
      <div>
        <p className="font-semibold" style={{ color: '#11194F' }}>{label}</p>
        <p className="text-sm text-gray-600 mt-1">{descripcion}</p>
      </div>
      <div className="relative inline-flex shrink-0">
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          className="sr-only peer"
        />
        <div className="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-[#22C55E] peer-disabled:cursor-not-allowed transition-colors" />
        <div className="absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform peer-checked:translate-x-5" />
      </div>
    </label>
  );
};
